export default __webpack_public_path__ + "static/media/IMG_4072.7881dfde.JPG";